<template>
	<div v-if="cartProducts.length > 0" class="no-scroll">
		<div class="title-wrapper">
			<div v-if="!featureToggles.favoriteRestaurants || isKioskChannel" class="basket-choice">{{deliveryChoice.title}}</div>
			<div v-else class="basket-choice favourite">
				<div class="basket-choice-restaurant">
					<div>{{deliveryChoice.title}}</div>
					<div>{{$store.getters.globalSelectedShop.shopName}}</div>
				</div>
				<div class="edit-favourite-restaurant" @click="protectOrderFlow(goToShopSelection)">
					<img :src="getImage('basket-edit-icon.svg')" alt="edit-restaurant">
				</div>
			</div>
			<div class="basket-title" data-gtm-basket-title="true">
				{{ $t("shopComponents.gt3.shoppingCart.shoppingCartCheckoutInit.shoppingCartEmpty") }}
			</div>
		</div>
		<div class="items-wrapper" :class="{ 'items-wrapper-with-voucher': voucherVisible || isVoucher, 'voucher-favourite-restaurant':  featureToggles.favoriteRestaurants}">
			<order-presentation
				:cartProducts="cartProducts"
				:cartOrderTags="cartOrderTags"
				:isProductConfiguring="isProductConfiguring"
				:productCatalog="productCatalog"
				:vouchersRedeemed="vouchersRedeemed"
				:globalSelectedShop="globalSelectedShop"
				:tenantSettings="tenantSettings"
			/>
		</div>
		<voucher-input
			v-if="voucherVisible || isVoucher"
			:cartProducts="cartProducts"
			:orderLines="orderLines"
			:vouchersRedeemed="vouchersRedeemed"
			:featureToggles="featureToggles"
			:globalSelectedShop="globalSelectedShop"
			:productCatalog="productCatalog"
			:voucherRef="voucherRef"
			@show-keyboard="showKeyboard"
			@hide-keyboard="hideKeyboard"
			:applyVoucherFromModal="applyVoucherFromModal"
		/>
		<v-btn v-if="isKioskChannel && (voucherVisible || isVoucher)" class="add-voucher" @click="showKeyboard">{{$t("utilityComponents.voucherInput.addVoucher")}}</v-btn>
		<sunset-points-input
			v-if="featureToggles.enableSunsetPoints"
		/>
		<confirmation-dialog
			:dialogOpened="dialogOpened"
			:onClose="closeConfirmDialog"
			:onConfirm="currentConfirmAction"
			:isProtectOrderFlow="true"
			:text="$t('shopComponents.defaultGlobalTemplate.orderMessages.orderMessagesWrapper.protectOrderFlow')"
			class="confirmation-dialog2"
		/>
		<v-dialog
			v-model="isKeyboardShown"
			v-if="isKioskChannel && isKeyboardShown"
			:content-class="`keyboard-dialog`"
		>
			<v-layout column class="kiosk-modal keyboard-layout">
				<div>
					<v-btn icon class="close-btn" @click="isKeyboardShown = false">
						<img  alt="" class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
					</v-btn>
					<v-layout class="keyboard-dialog-title">
						{{$t("utilityComponents.voucherInput.insertYourCode")}}
					</v-layout>
					<v-layout class="keyboard-dialog-body">
						<v-text-field
							type="text"
							class="voucher-modal-input"
							v-model="voucherRef"
							required
						></v-text-field>
						<keyboard-input
							v-if="voucherVisible && isKioskChannel && isKeyboardShown"
							:get-image="getImage('delete-number-icon.svg')"
							:keyboard-characters="keyboardCharacters"
							:show-additional-buttons="true"
							@inset-number="insertNumber"
							@delete-last-digit="deleteLastDigit"
							@hide-keyboard="hideKeyboard"
							class="keyboard"
						/>
						<v-btn class="green-btn keyboard-dialog-btn" @click="applyVoucher">
							{{$t("utilityComponents.voucherInput.approve")}}
						</v-btn>
						<v-layout class="keyboard-description">
							{{$t("utilityComponents.voucherInput.insertCodeDescription")}}
						</v-layout>
					</v-layout>
				</div>
			</v-layout>
		</v-dialog>
	</div>
	<div v-else class="shopping-cart-empty">
		<div v-if="!featureToggles.verticalKioskBasket" class="title-wrapper margin-bottom">
			<div v-if="!featureToggles.favoriteRestaurants || isKioskChannel" class="basket-choice">{{deliveryChoice.title}}</div>
			<div v-else class="basket-choice favourite">
				<div class="basket-choice-restaurant">
					<div>{{deliveryChoice.title}}</div>
					<div>{{$store.getters.globalSelectedShop.shopName}}</div>
				</div>
				<div class="edit-favourite-restaurant" @click="protectOrderFlow(goToShopSelection)">
					<img :src="getImage('basket-edit-icon.svg')" alt="edit-restaurant">
				</div>
			</div>
		</div>
		<div class="empty-container">
			<div class="empty-image">
				<img :src=deliveryChoice.href.black>
			</div>
			<div class="empty-message">
				{{ $t("shopComponents.gt3.shoppingCart.shoppingCartCheckoutInit.shoppingCartEmpty") }}
			</div>
			<div class="empty-message-description">
				<div>
					{{ $t("shopComponents.gt3.shoppingCart.shoppingCartCheckoutInit.shoppingCartEmptyDescription1") }}
				</div>
				<div class="position-bottom">
					{{ $t("shopComponents.gt3.shoppingCart.shoppingCartCheckoutInit.shoppingCartEmptyDescription2") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import {mapGetters} from "vuex";
	import * as Utils from "../../../../libraries/utils";
	import OrderPresentation from "./OrderPresentation-gt3";
	import VoucherInput from "../../../UtilityComponents/VoucherInput";
	import SunsetPointsInput from "../../../UtilityComponents/SunsetPointsInput";
	import appConfig, {channelEnum} from "../../../../appconfig";
	import * as mutationTypes from "../../../../store/mutation-types";
	import ConfirmationDialog from "../../../UtilityComponents/ConfirmationDialog";
	import protectOrderFlowMixin from "../../../../mixins/protectOrderFlow.mixin";
	import KeyboardInput from "../../../UtilityComponents/KeyboardInput.vue";

	export default {
		name: "ShoppingCartCheckoutInit-gt3",
		props: ["deliveryChoice", "isProductConfiguring", "isVoucher"],
		mixins: [protectOrderFlowMixin],
		components: {
			KeyboardInput,
			VoucherInput,
			SunsetPointsInput,
			OrderPresentation,
			ConfirmationDialog
		},
		data() {
			return {
				voucherRef: "",
				keyboardCharacters: [
					["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
					["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
					["A", "S", "D", "F", "G", "H", "J", "K", "L", "."],
					["Z", "X", "C", "V", "B", "N", "M"]
				],
				isKeyboardShown: false,
				applyVoucherFromModal: false
			};
		},
		async created(){
			const self = this;
			if (self.applicationUserLoggedIn && (self.featureToggles.enableSubscription || this.featureToggles.enableSunsetPoints)) {
				await self.$store.dispatch(mutationTypes.GATHER_USER_DATA, {page: this.$route.name});
				await self.setOrderTags();
			}
		},
		computed: {
			...mapGetters([
				"cartProducts", "totalPrice", "productCatalog", "tenantSettings",
				"getSpecialNotes", "discount", "globalSelectedShop", "orderLines", "customerFetchingSuccess",
				"cartOrderTags", "vouchersRedeemed", "featureToggles", "applicationUserLoggedIn", "subscriptionDetails"
			]),
			voucherVisible() {
				return this.featureToggles.voucherEnabled;
			},
			staticPath() {
				return Utils.getStaticPath();
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			},
			voucher() {
				return this.voucherRef;
			}
		},
		methods: {
			showKeyboard() {
				this.isKeyboardShown = true;
				this.applyVoucherFromModal = false;
			},
			hideKeyboard() {
				this.isKeyboardShown = false;
				this.voucherRef = "";
			},
			deleteLastDigit() {
				if(this.voucherRef.length === 1) {
					this.voucherRef = "";
				} else {
					this.voucherRef = this.voucherRef.toString().slice(0, -1);
				}
			},
			insertNumber(number) {
				this.voucherRef = this.voucherRef.toString().concat(number.toString());
			},
			handleVoucher(){},
			async setOrderTags() {
				return this.$store.dispatch(mutationTypes.RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS);
			},
			getImage(imageName) {
				return Utils.getMiscImageUrl(imageName);
			},
			goToShopSelection() {
				this.$router.push("/shop-selection");
			},
			applyVoucher() {
				this.isKeyboardShown = false;
				this.applyVoucherFromModal = true;
			}
		}
	};
</script>
<style scoped lang="scss">
	.v-dialog.keyboard-dialog {
		.keyboard-layout {
			background-image: none;
			margin-top: 50px;
			.close-btn {
				width: 80px;
				height: 80px;
				border-color: #FFFFFF;
				top: 80px;
				right: -10px;
				z-index: 1;
			}
		}
		.keyboard-dialog-title {
			display: flex;
			justify-content: center;
			font-size: 40px;
			padding-bottom: 30px;
		}
		.voucher-modal-input {
			padding: 0;
			margin-bottom: 4px;
			caret-color: #FFFFFF !important;
			/deep/ .v-input__slot {
				//background-color: #171618;
				background-color: #404040;
				height: 70px;
				margin-bottom: 0;
				input {
					max-height: 60px;
					height: 60px;
					font-size: 40px;
					text-align: center;
					color: white;
				}
				&:after {
					border-color: #171618;
				}
			}
			/deep/ .v-text-field__details {
				display: none;
			}

		}
		.keyboard-dialog-body {
			display: flex;
			flex-direction: column;
		}
		.keyboard-dialog-btn {
			height: 70px;
			font-size: 28px;
			text-transform: none;
			margin-top: 4px;
		}
		.keyboard-description {
			justify-content: center;
			padding-top: 30px;
			font-size: 16px;
		}
	}
	.add-voucher {
		opacity: 1;
		border-radius: 5px;
		background-color: #a6a6a6 !important;
		height: 72px;
		width: 100%;
		padding: 16px 24px 18px 24px;
		font-family: Dispatch-Bold;
		font-size: 24px;
		color: #ffffff;
		text-transform: none;
		margin: 22px 0;
		/deep/ .v-btn__content {
			justify-content: flex-start;
		}
	}
	.channel-kiosk.S1 {
		/deep/.v-overlay:before {
			opacity: 0.75;
		}
	}
	.shopping-cart-empty{
		padding-top: 16px !important;
		height: calc(100% - 108px);
		.empty-message{
			font-family: Dispatch-Black;
			font-size: 22px;
			font-weight: 900;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: center;
			color: #0d0109;
		}
		.empty-message-description{
			font-family: Dispatch-Light;
			font-size: 20px;
			font-weight: 300;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: center;
			color: #6d7278;
			margin: 32px 73px 0 74px;
			height: 112px;
			position: relative;
			.position-bottom{
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
			}
		}

	}

	.no-scroll{
		padding: 16px 16px 0px 16px;
		height: calc(100% - 108px);
	}
	.margin-bottom{
		margin-bottom: 114px !important;
	}
	.title-wrapper {
		margin-bottom: 16px;
		.basket-title {
			font-family: Dispatch-Black;
			font-size: 22px;
			font-weight: 900;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: left;
			color: #0d0109;
			text-transform: uppercase;
			padding-top: 24px;
			padding-left: 16px;
		}
		.basket-choice{
			text-transform: uppercase;
			font-family: Dispatch-Bold;
			padding: 16px;
			background-color: white;
		}
	}
	.shopping-cart-wrapper .items-wrapper{
		overflow-y: auto;
		height: calc(100% - 97px);
		&.items-wrapper-with-voucher {
			height: calc(100% - 196px);
			&.voucher-favourite-restaurant {
				height: calc(100% - 217px);
			}
		}
	}
	@media (max-width: 1537px) {
		.shopping-cart-wrapper .items-wrapper {
			&.items-wrapper-with-voucher {
				height: calc(100% - 180px);
				&.voucher-favourite-restaurant {
					height: calc(100% - 202px);
				}
			}
		}
	}
	@media (max-width: 1025px) {
		.voucher-part {
			&.voucher-empty {
				//height: 82px;
				margin: 0 -10px !important;
				padding: 0 10px !important;
			}
		}
		.shopping-cart-wrapper .items-wrapper{
			&.items-wrapper-with-voucher {
				height: calc(100% - 148px);
				&.voucher-favourite-restaurant {
					height: calc(100% - 180px);
				}
			}
		}
	}

	.no-padding {
		padding: 0 !important;
	}
	.voucher-part {
		position: sticky;
		bottom: 20px;
		background-color: #f6f6f6;

		&.voucher-empty {
			height: 82px;
			border-top: 1px solid #dbd5d5;
			margin: 0 -16px;
			padding: 0 16px;
		}
	}
	.favourite {
		display: flex;
		justify-content: space-between;
		padding-left: 16px;
		padding-right: 16px;
		border: solid 1px #e9e9e9;
		.basket-choice-restaurant div {
			font-size: 16px;
			text-transform: initial;
		}
		.edit-favourite-restaurant {
			width: 32px;
			height: 32px;
			background-color: #EAEAEA;
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 15px;
			cursor: pointer;
		}
	}

@media (-webkit-device-pixel-ratio: 1.25) {
	.title-wrapper {
		margin-bottom: 8px;
		.basket-choice{
			padding-bottom: 8px;
		}
	}
}
</style>
